export default "__VITE_ASSET__Tf9vyrEs__"